const messages = {
  placeholder: {
    id: 'admin/promotions.form.scope.products.select.placeholder',
  },
  label: {
    id: 'admin/promotions.form.scope.products.select.label',
  },
}

export default messages
